<template>
	<div class="ptrl-20-16 box-s">
			<ul>
        <li class="list_every pd-16 box-s mb-16" v-for="(item, index) in list" :key="index">
          <div class="flexs flex-jus mb-16">
             <div class="flexs">
							 <img class="wh_46 b-radius-50 mr-10" src="../../assets/img/icon/random_icon.png" alt="">
							 <div class="fw-500 fz-16 c1 w157 text-hide">{{item.title}}</div>
						 </div>

						 <div class="flexs bg_ec whl-74-24 flex-center fw-500 fz-12 b-radius-12 c0" @click="start(item.subject_id, item.all_question_amount, item.random_learn_question_id)"> 
								开始刷题
								<img class="wh_4_6 ml-5" src="../../assets/img/icon/blue_right_arrow.png" alt="">
							</div>
					</div>

					<div class="flexs c1fw-500 fz-14 l-h-46 plr-16 box-s bg_f9 b-radius-6">
						<div class="flex1">题目数量： {{item.all_question_amount}}题</div>
						<div class="flex1">已刷数量： {{item.achieve_question_amount}}题</div>
					</div>
				</li>
			</ul>
			<loading :loadFlag="loadFlag"></loading>
	</div>
</template>
<script>
	import loading from "@/components/loading"
	import {randomLearnSubject} from '@/api/api.js'
	export default {
		components: {
			loading
		},
		data() {
			return {
				list: [],
				loadFlag: false
			};
		},
		created() {
      this.initData()
		},
		mounted(){
    
		},
		methods: {
			async initData(){
				this.loadFlag = true
        const res = await randomLearnSubject()
				this.loadFlag = false
				if(res.code == 1000){
          this.list = res.data
				} else {
            this.$toast(res.msg)
          }
			},
			start(id, all_question_amount,random_learn_question_id){
				if(all_question_amount == 0){
          return this.$toast('暂无题目，无法开始做题哦~')
				} 
        this.$router.push({ path: '/randomstartquest', query: { subject_id: id, length: all_question_amount,random_learn_question_id } })
			}

		}
	};
</script>
<style lang="less" scoped>
</style>
